import { render } from "./OnlineCareRequestWithType.vue?vue&type=template&id=2f9193f2&scoped=true&ts=true"
import script from "./OnlineCareRequestWithType.vue?vue&type=script&lang=ts"
export * from "./OnlineCareRequestWithType.vue?vue&type=script&lang=ts"

import "./OnlineCareRequestWithType.vue?vue&type=style&index=0&id=2f9193f2&lang=scss&scoped=true"

import exportComponent from "D:\\Work\\HESEL\\DCS\\Client\\vuejs-dcs\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f9193f2"]])

export default __exports__